module.exports = __webpack_public_path__ + "img/202311_05.6270f665.jpg";